import React, { useState, useEffect } from 'react'
import { message } from 'antd'
import InputJsx from 'meinian-package/src/baseComponent/input'
import TextareaJSx from 'meinian-package/src/component/textarea'
import Modal from 'meinian-package/src/component/modal'
import request from 'meinian-package/src/utils/request'
import { MnInputNum } from 'meinian-package/src/component/imageDetail/styleSelect'
import TagList from 'meinian-package/src/component/imageDetail/tagSelection'
import { util } from 'meinian-package/src/utils'
import { useRequest } from 'ahooks'
import { UpgradeModal } from '../edit'
import styles from './index.module.less'

interface IQuickEdit{
    inspirationId:number,
    blogId: string,
    currentImage:any,
    visible: boolean,
    onEdit?:any,
    onVisibleChange: (val:boolean)=>void,
    setBanStatus?: React.Dispatch<React.SetStateAction<boolean>>,
    onChange: any,
    boxIndex?: number,
}

const Input:any = InputJsx
const Textarea:any = TextareaJSx

interface IQuickEditGroup{
  inspirationId:number,
  imageGroupEntityId: string,
  itemData:any,
  onChange: any,
  setBanStatus: React.Dispatch<React.SetStateAction<boolean>>,
  onDeleteItem: ()=>void,
  visible: boolean,
  onVisibleChange: (val:boolean)=>void,
}

export default function QuickEditGroup({
  visible,
  onVisibleChange,
  inspirationId,
  imageGroupEntityId,
  itemData,
  onChange,
  setBanStatus,
  onDeleteItem,
}: IQuickEditGroup) {
  const [editVisible, setEditVisible] = useState(false)

  const currentImage = { ...itemData, ...itemData.imageEntityExtend }

  useEffect(() => {
    if (editVisible) {
      setBanStatus?.(true)
    } else {
      setBanStatus?.(false)
    }
  }, [editVisible])

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>
    {
      visible && <QuickEdit
        inspirationId={inspirationId}
        blogId={imageGroupEntityId}
        currentImage={currentImage}
        onChange={onChange}
        visible={visible}
        onVisibleChange={onVisibleChange}
        onEdit={() => {
          setEditVisible(true)
          onVisibleChange(false)
        }}
        setBanStatus={setBanStatus}
      />
    }
    {editVisible ? <UpgradeModal
      visible={editVisible}
      setVisible={setEditVisible}
      inspirationId={inspirationId}
      onClose={() => { setEditVisible(false) }}
      currentImage={currentImage}
      onChange={(success, itemParams) => {
        onChange?.(success, itemParams)
        setEditVisible(false)
      }}
      blogId={imageGroupEntityId}
      onDeleteItem={onDeleteItem}
    /> : null}
  </>
}

export function QuickEdit({
  inspirationId,
  blogId,
  currentImage,
  onEdit,
  visible,
  onVisibleChange,
  setBanStatus,
  onChange,
  boxIndex = 0,
}: IQuickEdit) {
  const elements = (currentImage.boxLabelRetList && currentImage.boxLabelRetList[boxIndex]) || {}
  const { style, texture, technology, rootFabric, fabric, accessories, contour, collar, vamp, element, process, sole } = elements
  const finalElements = { texture, technology, fabric, accessories, contour, collar, vamp, element, process, sole, style }
  const hasElements = texture || technology || rootFabric || fabric || accessories || vamp || element || process || sole
  const showSmartTags = style || hasElements
  const [tags, setTags] = useState(new Set([]))
  const [params, setParams] = useState(currentImage)

  useRequest(async () => {
    const _tags:any = await request.get(`/zhikuan/img-tag/list-img-tag?entityId=${blogId}`)
    setTags(_tags?.map(m => ({ ...m, label: m.tagName, value: m.id })) || [])
  }, { ready: visible })

  const onChangeParams = (value) => {
    setParams(pre => ({ ...pre, ...value }))
  }

  const onSubmit = async () => {
    const tagList = [...tags]
    try {
      const param = {
        inspirationId,
        entityId: blogId,
        styleTitle: params.styleTitle,
        styleDesc: params.styleDesc,
        tagIdList: tagList.filter(m => m.value).map(m => m.value),
        tagNameList: tagList.filter(m => !m.value).map(m => m.label),
        price: params?.price && parseFloat(params.price),
        isQuickUpdate: true
      }
      await request.post('/zhikuan/ins/inspiration/add-style-info', param)
      message.success('修改成功！')
      const NParams = { // 不懂为什么是这个结构
        ...param,
        imageGroupEntityId: blogId,
        imageEntityExtend: {
          styleTitle: params.styleTitle
        },
      }
      onChange?.(true, NParams)
    } catch (err: any) {
      message.warning(err.errorDesc)
    }
    onVisibleChange(false)
    setBanStatus?.(false)
  }

  return <Modal
    centered
    title={<span style={{ color: 'var(--m-text-1)' }}>快速编辑</span>}
    className={styles.quickEditModal}
    width={556}
    visible={visible}
    maskClosable={false}
    onCancel={() => { onVisibleChange(false); setBanStatus?.(false) }}
    onOk={() => onSubmit()}
  >
    <div className="section-item" style={{ fontWeight: 500 }}>
      <span className="label">款式名称</span>
      <Input
        placeholder="输入款式名称，比如2021夏季连衣裙"
        withBorder
        wrapClassName="style-title-input-edit"
        value={params?.styleTitle}
        maxLength={50}
        showCount
        suffix={`${params.styleTitle?.length || 0}/50`}
        onChange={e => onChangeParams({ styleTitle: e.target.value })}
        wrapStyle={{ flex: 1, paddingLeft: 9 }}
      />
    </div>
    <div className="section-item">
      <span className="label">款式描述</span>
      <Textarea
        placeholder="输入内容，来让自己或其他成员更好的了解款式的面料，辅料、工艺、风格、颜色及卖点"
        wrapClassName="style-desc-textarea-edit"
        withBorder
        value={params?.styleDesc}
        suffix={<div className="suffix">{`${params.styleDesc?.length || 0}/400`}</div>}
        minHeight={100}
        maxLength={400}
        onInput={e => onChangeParams({ styleDesc: e.target.value })}
      />
    </div>

    <div className="section-item">
      <span className="label">添加标签</span>
      <TagList
        type="fetchInterface"
        className="style-lable-tag"
        value={tags}
        smartTags={finalElements}
        showSmartTags={showSmartTags}
        onChange={(value) => setTags(value)}
        suffix={20}
        style={{ width: '100%', marginBottom: 0 }}
        disabled={undefined}
        overlayStyle={undefined}
        localKey={undefined}
        localType={undefined}
        closeFold={undefined}
        wrapStyle={undefined}
      />
    </div>
    <div className="section-item">
      <span className="label">参考价格</span>
      <MnInputNum
        decimalPlaces={2}
        value={params?.price}
        maxNum={10000000}
        onChange={(value) => {
          if (Math.ceil(Number(value)) > 10000000) {
            return message.warning('最多支持输入9999999.99')
          }
          onChangeParams({ price: value || 0 })
        }}
      />
    </div>
    <button
      type="button"
      className="edit-more-btn"
      onClick={() => {
        util.track('mn_edit_style', {
          module1: '款式详情页',
          module2: '款式详情',
        })
        onEdit?.()
        // onVisibleChange(false)
      }}
    >编辑更多信息</button>
  </Modal>
}
